import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { Employee } from '@fc-core/models';

const AVATAR_TEXT_SIZE_CLASSES = [
  { minSize: 56, className: 'text-2xl leading-36' },
  { minSize: 40, className: 'text-xl leading-32' },
  { minSize: 32, className: 'text-base leading-24' },
  { minSize: 24, className: 'text-sm leading-20' },
  { minSize: 20, className: 'text-xs leading-16' },
  { minSize: 0, className: 'text-xxs' },
] as const;

@Component({
  selector: 'fc-avatar-placeholder',
  template: `
    <div
      [style.width.px]="size()"
      [style.height.px]="size()"
      [style.background]="color()"
      [class.rounded-full]="shape() === 'circle'"
      [class.rounded]="shape() === 'square'"
      class="flex items-center justify-center bg-secondary-400"
    >
      <div
        [ngClass]="textSizeClass()"
        [class.font-medium]="size() >= 24"
        [class.font-normal]="size() < 24"
        class="text-white uppercase"
      >
        {{ placeholder() }}
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class AvatarPlaceholderComponent {
  readonly employee = input<Employee | null>(null);
  readonly text = input<string | null>(null);
  readonly placeholder = computed(() => {
    const employee = this.employee();
    if (employee) {
      const firstName = employee.firstName || '';
      const lastName = employee.lastName || '';
      return firstName.charAt(0) + lastName.charAt(0);
    } else {
      return this.text() || '';
    }
  });
  readonly color = input<string>();
  readonly shape = input<'circle' | 'square'>('circle');
  readonly size = input<number>(28);
  readonly fontSize = input<number>(14);
  readonly textSizeClass = computed(
    () =>
      AVATAR_TEXT_SIZE_CLASSES.find(({ minSize }) => this.size() >= minSize)
        ?.className ?? 'text-xs',
  );
}
